import { SidebarHeader } from '@ibsys/kit';
import { useTheme } from '@/app/providers/ThemeProvider';
import { FC } from 'react';
import { cn } from '@/shared/lib';
import DOMPurify from 'dompurify';

type Props = {
  className?: string;
};

/** Проверяет, является ли значение inline SVG-разметкой (а не URL или data URI) */
const isInlineSvg = (value: string) => value.trimStart().startsWith('<');

export const AppSidebarHeader: FC<Props> = ({ className }) => {
  const { logoSvg } = useTheme();

  if (!logoSvg) {
    return (
      <SidebarHeader
        className={cn('flex flex-col bg-sidebar border-b border-sidebar-border justify-center', className)}
      />
    );
  }

  if (isInlineSvg(logoSvg)) {
    const cleanSvg = DOMPurify.sanitize(logoSvg, { USE_PROFILES: { svg: true } });

    return (
      <SidebarHeader
        className={cn('flex flex-col bg-sidebar border-b border-sidebar-border justify-center', className)}
      >
        <div dangerouslySetInnerHTML={{ __html: cleanSvg }} />
      </SidebarHeader>
    );
  }

  return (
    <SidebarHeader className={cn('flex flex-col bg-sidebar border-b border-sidebar-border justify-center', className)}>
      <img src={logoSvg} alt="" className="h-8 w-auto object-contain object-left" />
    </SidebarHeader>
  );
};
